import { render, staticRenderFns } from "./section.vue?vue&type=template&id=54e8f6ff&"
import script from "./section.vue?vue&type=script&lang=js&"
export * from "./section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ApzLoading: require('/builds/apzfront/forerunner/components/base/ApzLoading.vue').default,ApzIcon: require('/builds/apzfront/forerunner/components/base/ApzIcon.vue').default,ApzCollapse: require('/builds/apzfront/forerunner/components/base/ApzCollapse.vue').default})
